import synthesizeSpeech from "./synthesizeSpeech";

export const textToSpeech = async ({ text = '', language, voiceId, audioRef }) => {
  const input = {
      engine: 'neural',
      languageCode: language,
      voiceId: voiceId,
      text
  };

  const { audioUrl } = await synthesizeSpeech(input);

  if (audioRef?.current) {
      try {
        audioRef.current.src = audioUrl;
        await audioRef.current.play();
      } catch (error) {
        console.error(error);
        throw error
      }
  }
};
